import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import { newsCommunicator } from '../../../../../../../communicators/newsCommunicator'
import { regionalChambersCommunicator } from '../../../../../../../communicators/regionalChambersCommunicator'

import { SectionTitle } from '../../../../../../components/SectionTitle/SectionTitle'
import { ErrorBoundary } from '../../../../../../components/ErrorBoundary/ErrorBoundary'
import { DetailsLink } from '../../../../../../components/DetailsLink/DetailsLink'
import { RCRelatedNewsList } from './RCRelatedNewsList/RCRelatedNewsList'

import './RCRelatedNews.css'

class RCRelatedNews extends Component {
    constructor(props) {
        super(props)
        this.state = {
            relatedNewsList: []
        }
    }

    componentDidMount() {
        this.loadRelatedNews()
    }

    async loadRelatedNews() {
        try {
            const { slug } = this.props
            const chamber = await regionalChambersCommunicator.fetchChamber(slug)

            const { article } = this.props
            const relatedNewsList = await newsCommunicator.fetchRCRelatedNews(chamber.id, article)
            this.setState({ relatedNewsList })
        } catch (error) {
            console.error(error.message)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.article.id !== prevProps.article.id) {
            this.loadRelatedNews()
        }
    }

    onMoreRelatedNews = () => {
        this.props.history.push(`/sve-vesti`)
    }

    render() {
        const { t } = this.props
        const { relatedNewsList } = this.state

        if (_.isEmpty(relatedNewsList)) {
            return null
        }

        return (
            <div className="related-news">
                <div className="related-news__title section-title-centered">
                    <SectionTitle title={t('singleArticle.relatedNews.title')} underlineClass />
                </div>
                <ErrorBoundary>
                    <RCRelatedNewsList relatedNewsList={relatedNewsList} />
                </ErrorBoundary>
                <DetailsLink
                    text={t('singleArticle.relatedNews.details')}
                    onDetailsClick={this.onMoreRelatedNews}
                />
            </div>
        )
    }
}

RCRelatedNews.propTypes = {
    t: PropTypes.func
}

export { RCRelatedNews }
export default withTranslation()(withRouter(RCRelatedNews))
